const partner_list = {
    path: 'partner_list',
    component: resolve => require(['@/pages/admin/storage_audit/partner_list.vue'], resolve),
}

export default partner_list